export const AdCampaignStatus = {
	ACTIVE: 'ACTIVE',
	DRAFT: 'DRAFT',
	COMPLETED: 'COMPLETED',
};
